import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../queryKeys";
import { cdFetch } from "../api";
import { HomeData, HomeFilterRes } from "../../services/interfaces/IHomePage";

const normalize = (input?: Array<string> | null) => {
  if (!Array.isArray(input) || input.length === 0) return null;
  return input.slice().sort();
};

const getQueryParams = (
  commodity: string | null,
  district?: string[] | null
) => {
  let qParams = "";
  if (commodity != null && commodity.length > 0) {
    qParams += `commodity=${JSON.stringify(commodity)}&`;
  }
  if (district && district.length > 0) {
    qParams += `district=${JSON.stringify(district)}&`;
  }

  if (qParams.length > 0) {
    qParams = "?" + qParams.slice(0, -1);
  }

  return qParams;
};

export const useHomeFilters = (
  // commodity: string | null,
  // district?: string[] | null,
  userEmail: string | null
) => {
  const { data: res, isLoading } = useQuery({
    // queryKey: [queryKeys.home, "filters", commodity, normalize(district)],
    // queryFn: () => getFilters(commodity, district),
    queryKey: [queryKeys.home, userEmail],
    queryFn: () => getFilters(userEmail),
    enabled:
      userEmail &&
        userEmail !== "" &&
        userEmail !== null &&
        userEmail !== undefined
        ? true
        : false,
  });
  const fetchFilters: HomeFilterRes = { ...res?.data };
  return { fetchFilters, isLoading };
};

const getFilters = (
  // commodity: string | null,
  // district?: string[] | null
  userEmail: string | null
) => {
  // const queryParams = getQueryParams(commodity, district);
  // const res = cdFetch(`/getAllFiltersLandingPage${queryParams}`);
  const res = cdFetch(
    `/getAllFiltersLandingPage?email=${JSON.stringify(userEmail)}`
  );
  return res;
};

// export const useUserDetails = (userEmail: string) => {
//   const { data, isLoading } = useQuery({
//     queryKey: [queryKeys.userDetails, userEmail],
//     queryFn: () => getUserDetails(userEmail),
//     enabled: userEmail ? true : false,
//   });
//   return { userDetails: { ...data?.data }, isLoading };
// };

export const useUserDetails = (userEmail: string) => {
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.userDetails, userEmail],
    queryFn: () => getUserDetails(userEmail),
    enabled: userEmail ? true : false,
  });

  let userDetails = { ...data?.data };

  // if (
  //   userDetails?.role_name === "Lead" &&
  //   Array.isArray(userDetails.district_level_data)
  // ) {
  //   const toCopy = userDetails.district_level_data[0];
  //   if (toCopy) {
  //     const newObj = { ...toCopy, COMMODITY: "Copper Wire" };
  //     userDetails = {
  //       ...userDetails,
  //       district_level_data: [...userDetails.district_level_data, newObj],
  //     };
  //   }
  // }

  return { userDetails, isLoading };
};

const getUserDetails = (email: string) => {
  // const res = cdFetch(`/getUserData?user_email=${JSON.stringify(email)}`);
  const res = cdFetch(
    `/getUserAccessDetails?user_email=${JSON.stringify(email)}`
  );
  return res;
};

export const useHomeData = (
  userEmail: string | null,
  commodity: string | null,
  district: string[] | null,
  isEnabled?: boolean,
  isJPExcluded: number = 1
) => {
  const { data: res, isLoading } = useQuery({
    queryKey: [
      queryKeys.home,
      "kpi",
      commodity,
      normalize(district),
      userEmail,
      isJPExcluded,
    ],
    queryFn: () => getHomeData(commodity, userEmail, district, isJPExcluded),
    enabled: isEnabled ? commodity !== null && userEmail !== null && district !== null : userEmail !== null,
    staleTime: 1000,
  });
  let data: HomeData = res?.data;
  return { data, isLoading };
};

const getHomeData = (
  commodity: string | null,
  userEmail: string | null,
  district?: string[] | null,
  isJPExcluded: number = 1
) => {
  const queryParams = getQueryParams(commodity, district);
  const newQueryParam = `${queryParams ? `${queryParams}&` : "?"
    }email=${JSON.stringify(userEmail)}&isJPExcluded=${isJPExcluded}`;
  const res = cdFetch(`/getLandingPageData${newQueryParam}`);
  return res;
};
